import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import FlatButton from 'material-ui/FlatButton'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import SocialShare from 'material-ui/svg-icons/social/share'
import plural from '../../lib/plural'
import Fullscreen from '../common/fullscreen/Fullscreen'
import Page from '../common/page/Page'
import Poll from '../../models/Poll'
import Bar from '../common/charts/Bar'
import { colors } from '../common/charts/colors'
import Remove from './Remove'
import './Results.less'

export default class Results extends React.Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentWillMount() {
		this.props.load()
	}

	componentDidMount() {
		this.updateChartData(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.updateChartData(nextProps)
	}

	updateChartData({ poll, results }) {
		if (!(poll && results && results.length)) return

		const totalVotes = results.reduce((total, votes) => total + votes, 0)

		const percentages = results.map((votes) =>
			Math.round((votes / totalVotes) * 100)
		)

		const labels = poll.options.map((option, i) =>
			`${option} (${percentages[i]}%)`
		)

		const barData = labels.map((label, i) => ({
			label,
			value: results[i],
			percent: percentages[i],
		}))

		this.setState({
			barData,
			data: {
				labels,
				datasets: [{
					data: results,
					backgroundColor: colors,
					hoverBackgroundColor: colors,
				}],
			},
			percentages,
			totalVotes,
		})
	}

	render() {
		if (!(this.props.poll && this.props.results)) {
			return null
		}

		const { key, question } = this.props.poll

		const pageTitle = `(${this.state.totalVotes}) ${question}`

		return (
			<Page className="results" title="Results" pageTitle={pageTitle} showBack>
				<p className="question">{question}</p>
				{this.state.totalVotes ? (
					<div className="graph">
						<p className="votes">
							{plural(this.state.totalVotes, 'vote')}
						</p>
						<Bar dataset={this.state.barData} />
					</div>
				) : (
					<div className="empty">
						<p>No votes yet.</p>
						<p>Share it with more people using the share button!</p>
					</div>
				)}
				<div className="actions pinned top">
					<Fullscreen secondary />
				</div>
				<div className="actions pinned">
					<FloatingActionButton
						onClick={() => browserHistory.push(`/${key}/send`)}
					>
						<SocialShare />
					</FloatingActionButton>
				</div>
				<div className="actions">
					<FlatButton
						label="Go vote"
						onClick={() => browserHistory.push(`/${key}`)}
					/>
					{this.props.enableRemove ? (
						<Remove remove={this.props.remove} />
					) : null }
				</div>
			</Page>
		)
	}
}

Results.propTypes = {
	enableRemove: PropTypes.bool,
	load: PropTypes.func.isRequired,
	poll: PropTypes.instanceOf(Poll),
	remove: PropTypes.func.isRequired,
	results: PropTypes.arrayOf(PropTypes.number),
}



// WEBPACK FOOTER //
// ./src/components/results/Results.jsx